import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgWindowIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 16h24M16 4v24M10.4 4h11.2c2.2402 0 3.3603 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.0397 28 8.1598 28 10.4v11.2c0 2.2402 0 3.3603-.436 4.216a4 4 0 0 1-1.748 1.748C24.9603 28 23.8402 28 21.6 28H10.4c-2.2402 0-3.3603 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.9603 4 23.8402 4 21.6V10.4c0-2.2402 0-3.3603.436-4.216a4 4 0 0 1 1.748-1.748C7.0397 4 8.1598 4 10.4 4"
    />
  </svg>
);
export default SvgWindowIcon;
